export enum AlivenessMetricCategory {
  AVAILABILITY = 'availability',
  NON_ALIVE = 'nonAlive',
  OFFLINE_MANUALLY = 'offlineManually',
}

export enum OfflineInterval {
  DAY = 'day',
  HOUR = 'hour',
}

export enum OfflineMinutesPerHour {
  OFFLINE_DUE_TO_ISSUE = 'OFFLINE_DUE_TO_ISSUE',
  MANUALLY_PUT_OFFLINE = 'MANUALLY_PUT_OFFLINE',
}
